import {
  BookMarkedIcon,
  CreditCardIcon,
  GlobeIcon,
  KeyRoundIcon,
  LibraryBigIcon,
  ShieldCheckIcon,
  SquareCodeIcon,
  UserRoundIcon,
} from 'lucide-react';
import {useConfig} from '@tinct/core-config';

export const useWorkspaceSettingsNavigation = (workspaceBaseUrl: string, isAgency = false) => {
  // Domain & hosting only applies when landing-page generation is enabled.
  const {isFeatureEnabled} = useConfig();
  const landingPageGenerationEnabled = isFeatureEnabled('landingPageGeneration');

  if (isAgency) {
    return [
      {
        title: 'Teams',
        url: `${workspaceBaseUrl}/settings/teams`,
        icon: UserRoundIcon,
      },
      {
        title: 'Security',
        url: `${workspaceBaseUrl}/settings/security`,
        icon: ShieldCheckIcon,
      },
      {
        title: 'Billing',
        url: `${workspaceBaseUrl}/settings/billing`,
        icon: CreditCardIcon,
      },
    ];
  }

  return [
    {
      title: 'Brand Guidelines',
      url: `${workspaceBaseUrl}/settings/brand-guidelines`,
      icon: BookMarkedIcon,
    },
    {
      title: 'Snippet',
      url: `${workspaceBaseUrl}/settings/snippet`,
      icon: SquareCodeIcon,
    },
    ...(landingPageGenerationEnabled ? [{
      title: 'Domain & hosting',
      url: `${workspaceBaseUrl}/settings/domain-hosting`,
      icon: GlobeIcon,
    }] : []),
    {
      title: 'Integrations',
      url: `${workspaceBaseUrl}/settings/integrations`,
      icon: LibraryBigIcon,
    },
    {
      title: 'Teams',
      url: `${workspaceBaseUrl}/settings/teams`,
      icon: UserRoundIcon,
    },
    {
      title: 'Security',
      url: `${workspaceBaseUrl}/settings/security`,
      icon: ShieldCheckIcon,
    },
    {
      title: 'Service Account',
      url: `${workspaceBaseUrl}/settings/service-accounts`,
      icon: KeyRoundIcon,
    },
    {
      title: 'Billing',
      url: `${workspaceBaseUrl}/settings/billing`,
      icon: CreditCardIcon,
    },
  ]
}
